import { memo } from "react";

import useTypedContext from "hooks/useTypedContext";
import TableCell from "components/Table/Cell";
import { TableContext } from "components/Table/Context";

import { IDP_GROUP_USERS_COLUMN_ID } from "../constants";
import IdpGroupUsersListItemNameCell from "./NameCell";
import IdpGroupUsersListItemLastLoginCell from "./LastLoginCell";
import IdpGroupUsersListItemStatusCell from "./StatusCell";
import IdpGroupUsersListItemMethodCell from "./MethodCell";
import { IdpGroupViewManagedUser } from "../../types";

const CELLS = {
  [IDP_GROUP_USERS_COLUMN_ID.NAME]: IdpGroupUsersListItemNameCell,
  [IDP_GROUP_USERS_COLUMN_ID.LAST_LOGIN]: IdpGroupUsersListItemLastLoginCell,
  [IDP_GROUP_USERS_COLUMN_ID.STATUS]: IdpGroupUsersListItemStatusCell,
  [IDP_GROUP_USERS_COLUMN_ID.METHOD]: IdpGroupUsersListItemMethodCell,
};

type IdpGroupUsersListItemProps = {
  user: IdpGroupViewManagedUser;
};

const IdpGroupUsersListItem = (props: IdpGroupUsersListItemProps) => {
  const { user } = props;

  const { visibleColumnIds } = useTypedContext(TableContext);

  return (
    <>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as IDP_GROUP_USERS_COLUMN_ID];
        const uniqueKey = `${id}-${user.id}`;

        const childrenComponent = <Component user={user} />;

        return (
          <TableCell key={uniqueKey} id={id}>
            {childrenComponent}
          </TableCell>
        );
      })}
    </>
  );
};

export default memo(IdpGroupUsersListItem);
